<template>
  <div class="mb-5">
    <!-- topbar -->
    <div class="flex items-center justify-between pb-3.5 border-b border-line">
      <div class="flex items-center gap-2 min-w-0">
        <button
          v-if="showMobileToggle"
          @click="$emit('toggle-nav')"
          class="md:hidden text-text-2 hover:text-text p-1 rounded hover:bg-bg-2"
          aria-label="Open navigation"
        >
          <Menu :size="18" />
        </button>
        <nav class="font-mono text-[11.5px] text-text-3 truncate">
          <template v-for="(c, i) in crumbs" :key="i">
            <span v-if="i > 0" class="mx-1.5">/</span>
            <span :class="i === crumbs.length - 1 ? 'text-text font-medium' : ''">{{ c }}</span>
          </template>
        </nav>
      </div>
      <div class="flex items-center gap-2">
        <slot name="actions" />
      </div>
    </div>
    <!-- title -->
    <div class="flex items-baseline gap-3 flex-wrap mt-4">
      <h1 class="text-[24px] font-semibold tracking-tight text-text">{{ title }}</h1>
      <p v-if="subtitle" class="text-[13px] text-text-3">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Menu } from 'lucide-vue-next';

const props = defineProps({
  title:            { type: String, required: true },
  subtitle:         { type: String, default: '' },
  breadcrumb:       { type: [String, Array], default: '' },
  showMobileToggle: { type: Boolean, default: true },
});
defineEmits(['toggle-nav']);

const crumbs = computed(() =>
  Array.isArray(props.breadcrumb) ? props.breadcrumb : props.breadcrumb.split('/').map(s => s.trim())
);
</script>
